import Api from '../utils/Api';

const get = (caller, id = null) => {
    let url = '/users';
    if (id) {
        url += `/${id}`;
    }

    return Api.makeRequest(url, 'GET', null, caller, id);
};

const register = (caller, data) => {
    // data = {
    //     "email": "string",
    //     "fullname": "string",
    //     "plainPassword": "string"
    // }

    return Api.makeRequest('/users', 'POST', data, caller, data);
};

const update = (caller, data) => {
    // data = {
    //     "plainPassword": "string"
    // }
    return Api.makeRequest('/users/me', 'PUT', data, caller, data);
};

const logout = (caller) => {
    return new Promise((resolve) => {
        localStorage.removeItem('token');

        window.location = "/";

        resolve();
    });
};

const getStats = (caller, id) => {
    return Api.makeRequest(`/users/${id}/statistics`, 'GET', null, caller, id);
};

const invite = (caller, email) => {
    return Api.makeRequest(`/send-invitation`, 'POST', {email}, caller, email);
};

export { get, register, update, getStats, logout, invite };


// WEBPACK FOOTER //
// ./src/models/User.js